/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse_string_ } from '../models/ListResponse_string_';
import { request as __request } from '../core/request';

export class DaDataService {

    /**
     * @param query
     * @returns ListResponse_string_ Ok
     * @throws ApiError
     */
    public static async getAddressSuggestions(
        query?: string,
    ): Promise<ListResponse_string_> {
        const result = await __request({
            method: 'GET',
            path: `/dadata/suggestions/address`,
            query: {
                'query': query,
            },
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @param code
     * @returns ListResponse_string_ Ok
     * @throws ApiError
     */
    public static async getFmsUnitSuggestions(
        code?: string,
    ): Promise<ListResponse_string_> {
        const result = await __request({
            method: 'GET',
            path: `/dadata/suggestions/fms-unit`,
            query: {
                'code': code,
            },
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}